module.exports = new __parcel__URL__("banner-2.f3bc8694.png").toString();